export default __webpack_public_path__ + "static/media/team3@2x.923bf8c8.png";